/* eslint-disable consistent-return */
import { Button, Grid } from '@material-ui/core';
import {
  deleteStudentCertification,
  postStudentCertification,
  updateStudentCertification,
} from '@webapps/business';
import {
  FormikDatePicker,
  FormikTextField,
  Loader,
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Row from 'components/Form/Row';
import { format } from 'date-fns';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const certificationSchema = yup.object().shape({
  label: yup.string().required('Requis'),
  reference: yup.string().required('Requis'),
  issuingCompany: yup.string().required('Requis'),
  issueDate: yup.string().required('Requis'),
  expirationDate: yup.string().required('Requis'),
});

const AddCertification = ({
  close,
  refetch,
  initialData = {},
  isLoadingEdit,
  idEdit,
}) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { idUser } = useAuth();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateCertification,
  } = useMutation(postStudentCertification);

  const {
    isLoading: isLoadingUpdate,
    isSuccess: isSuccessUpdate,
    mutateAsync: mutateUpdateCertification,
  } = useMutation(updateStudentCertification);

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteCertification,
  } = useMutation(deleteStudentCertification);

  const deleteCertification = async (id) => {
    await mutateDeleteCertification({
      id,
    });
  };

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccess || isSuccessDelete || isSuccessUpdate) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      close();
    }
  }, [isSuccess, isSuccessDelete, isSuccessUpdate]);

  const formik = useFormik({
    initialValues: {
      label: initialData?.label || '',
      reference: initialData?.reference || '',
      issuingCompany: initialData?.issuingCompany || '',
      issueDate: initialData.issueDate || '',
      expirationDate: initialData?.expirationDate || '',
    },
    validationSchema: certificationSchema,
    enableReinitialize: true,
    onSubmit: async ({
      expirationDate,
      issueDate,
      issuingCompany,
      label,
      reference,
    }) => {
      if (idEdit) {
        await mutateUpdateCertification({
          data: {
            issueDate: format(new Date(issueDate), "yyyy-MM-dd'T'HH:mm:ss"),
            expirationDate: format(
              new Date(expirationDate),
              "yyyy-MM-dd'T'HH:mm:ss"
            ),
            issuingCompany,
            reference,
            label,
          },
          id: idEdit,
        });
      } else {
        await mutateCertification({
          data: {
            issueDate: format(new Date(issueDate), "yyyy-MM-dd'T'HH:mm:ss"),
            expirationDate: format(
              new Date(expirationDate),
              "yyyy-MM-dd'T'HH:mm:ss"
            ),
            issuingCompany,
            reference,
            label,
          },
          id: idUser,
        });
      }
    },
  });

  if (isLoadingEdit) {
    return <Loader />;
  }

  return (
    <div>
      <Row>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Intitulé de la certification"
              name="label"
            />
          </Grid>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label={<FormattedMessage id="addCertification.reference" />}
              name="reference"
            />
          </Grid>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label={<FormattedMessage id="addCertification.issuingCompany" />}
              name="issuingCompany"
            />
          </Grid>
          <Grid item xs={12}>
            <FormikDatePicker
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Date de délivrance"
              name="issueDate"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12}>
            <FormikDatePicker
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Date d'expiration"
              name="expirationDate"
              variant="outlined"
            />
          </Grid>
        </Grid>
      </Row>
      <Row>
        <Grid container spacing={2}>
          <Grid className={css({ textAlign: 'center' })} item xs>
            <Button
              className={css({ borderRadius: '400px' })}
              color="primary"
              disabled={isLoading || isLoadingUpdate || isLoadingDelete}
              onClick={formik.handleSubmit}
              variant="contained"
            >
              <FormattedMessage id="vitrine.btnCreate" />
            </Button>
            {idEdit && (
              <Button
                className={css({ borderRadius: '400px', marginLeft: spacing(1), backgroundColor: "#FBD3D5" })}
                color="secondary"
                disabled={isLoading || isLoadingUpdate || isLoadingDelete}
                onClick={() => deleteCertification(idEdit)}
                variant="outlined"
              >
                <FormattedMessage id="btnDelete" />
              </Button>
            )}
          </Grid>
        </Grid>
      </Row>
    </div>
  );
};

AddCertification.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
  initialData: PropTypes.object,
  isLoadingEdit: PropTypes.bool,
  idEdit: PropTypes.string,
};

export default AddCertification;
